import {
	ref,
	get,
	remove,
	runTransaction,
	getDatabase,
} from "firebase/database";

const database = getDatabase();

export const unclaimOffer = async ({ offerId, shopId, mobileNo }) => {
	try {
		const claimRef = ref(database, `claims/${offerId}/${mobileNo}`);

		const countRef = ref(
			database,
			`offers/byShop/${shopId}/${offerId}/claimCount`,
		);

		const snap = await get(claimRef);

		if (!snap.exists()) {
			return;
		}

		await remove(claimRef);

		await runTransaction(countRef, (current) =>
			Math.max(0, (current || 0) - 1),
		);

		return {
			success: true,
		};
	} catch (err) {
		console.log(err);
	}
};
